import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08d8de20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-list container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }

import { ref } from 'vue'
    import axios from 'axios'
    import {
        ArrowLeft,
        ArrowRight
    } from '@element-plus/icons-vue'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'the-footer',
  props: ['loading', 'data'],
  emits: ['submitQuestion', 'previous', 'next'],
  setup(__props, { emit: __emit }) {

    const props = __props
    const emit = __emit
    const qu = ref<string>('')
    const isLoading:boolean = ref(false)

    const submitHandler = () => {
        emit('submitQuestion', true);
    }

    const previousHandler = () => {
        emit('previous', true);
    }

    const nextHandler = () => {
        emit('next', true);
    }
    

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_footer = _resolveComponent("el-footer")!

  return (_openBlock(), _createBlock(_component_el_footer, { class: "footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: previousHandler,
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowLeft))
                ]),
                _: 1
              }),
              _createTextVNode("上一题")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: nextHandler,
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一题"),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: submitHandler,
            size: "large",
            type: "danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode("交卷")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})